import pantryTemplate from "../templates/pages/pantry.html?raw";
import NavBar from "../sections/navbar.ts";
import { Page } from "./base.ts";
import { getElementById, getElementDataForEach, setContent } from "../services/dom.ts";
import Footer from "../sections/footer.ts";

export default class PantryPage extends Page {
  constructor() {
    super(pantryTemplate);
    this.loadPage();
  }

  private async loadPage(): Promise<void> {
    // Create navbar and footer immediately
    new NavBar();
    new Footer();

    // Initialize stores and load data
    await super.init();
    await this.loadData();
    setContent("inventory");
  }

  private async loadData(): Promise<void> {
    await this.inventoryStore.getInventory(true);
    this.populateList();
  }

  private populateList(): void {
    const inventoryItemTemplate = getElementDataForEach("inventory");
    const inventoryItemTemplateParent = inventoryItemTemplate.parentElement;
    inventoryItemTemplate.classList.remove("hidden");
    this.inventoryStore.inventory.forEach((item: any) => {
      const inventoryItem = inventoryItemTemplate.cloneNode(true) as HTMLDivElement;
      inventoryItem.querySelector("[data-selector='ingredientName']")!.textContent = item.ingredient_name;
      inventoryItem.querySelector("[data-selector='ingredientAmount']")!.textContent = `${Math.round((item.quantity as number) * 100) / 100} ${item.unit_suffix}`;
      inventoryItem.querySelector("[data-selector='removeFromInventory']")!.addEventListener("click", async () => {
        try {
          await this.inventoryStore.removeFromInventory(item);
          inventoryItem.remove();
        } catch (e: any) {
          this.message.timedMessage(`⚠ Unexpected error deleting item from inventory ⚠`);
          console.log(e);
          throw new Error(e);
        }
      });
      inventoryItemTemplateParent?.appendChild(inventoryItem);
    });
    inventoryItemTemplate.classList.add("hidden");
    const clearAllButton = getElementById("clearAllButton");
    clearAllButton.addEventListener("click", async () => {
      try {
        inventoryItemTemplateParent?.querySelectorAll("[data-for-each=inventory]").forEach((element) => {
          element.remove();
        });
        this.inventoryStore.clearInventory();
      } catch (e: any) {
        this.message.timedMessage(`⚠ Unexpected error clearing inventory ⚠`);
        console.log(e);
        throw new Error(e);
      }
    });
  }
}
